export default __webpack_public_path__ + "static/media/Data Insights.84a34622.svg";